import { render, staticRenderFns } from "./BossCardBox.vue?vue&type=template&id=3d670081&scoped=true"
import script from "./BossCardBox.vue?vue&type=script&lang=js"
export * from "./BossCardBox.vue?vue&type=script&lang=js"
import style0 from "./BossCardBox.vue?vue&type=style&index=0&id=3d670081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d670081",
  null
  
)

export default component.exports